<template>
  <div :value="value" v-bind="$attrs" v-on="$listeners">
    <label>
      <v-text-field
        :value="getValue"
        @click="$listeners.click ? '' : showPicker()"
        :style="isOnMobile ? 'font-size: 14px;' : ''"
        class="t-date-time-range-picker ma-0 pa-0"
        readonly
        maxlength="10"
        :label="label"
        dense
        hide-details
        :append-icon="getValue ? '' : 'mdi-calendar-month'"
        :clearable="clearable"
        @click:clear="clearDates()"
      ></v-text-field>
    </label>
  </div>
</template>

<script>
import { g_Dialog, TR } from "../../main";
export default {
  props: {
    value: {
      type: Array,
      default: () => [null, null],
    },
    label: {
      type: String,
      default: () => TR.TDatePicker_FromDateToDate,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modalCalendar_range: false,
      dates: [this.value[0], this.value[1]],
      datesText: "",
    };
  },
  methods: {
    showPicker() {
      g_Dialog.show(g_Dialog.dialog_types.date_picker, this.value, null, (dates) => {
        if (dates != null) {
          this.dates = [dates[0], dates[1]];
        } else {
          this.dates = this.value;
        }
        console.log("showPickerEnd");
        this.$emit("input", this.dates);
        this.$emit("change", this.dates);
      });
    },
    clearDates() {
      this.dates[0] = null;
      this.dates[1] = null;
      this.$emit("input", this.dates);
      this.$emit("change", this.dates);
    },
    getFormat() {
      if (this.userSettings.showTimeOnDatePicker) {
        return "dd.MM.yyyy HH:mm";
      } else {
        return "dd.MM.yyyy";
      }
    },
  },
  computed: {
    getValue() {
      return (this.dates[0] ? new Date(this.dates[0]).toStringWithFormat(this.getFormat()) + " - " : "") + (this.dates[1] ? new Date(this.dates[1]).toStringWithFormat(this.getFormat()) : "");
    },
  },
  watch: {
    value: {
      handler() {
        this.dates = this.value;
      },
      deep: true,
    },
  },
  mounted() {},
};
</script>
<style scoped>
.t-date-time-range-picker >>> input {
  cursor: pointer;
}
</style>